import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Typography,
  Grid,
  Container,
  Button,
  InputLabel,
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Aux from "../../hoc/Auxilliary";
import { isObjectEmpty } from "../../utils/general";
import { useSelector, useDispatch } from "react-redux";
import {
  getInvoiceData,
  clearErrorStatusCode,
  clearErrorMessage,
  saveFileUploadData,
} from "../../reduxSlices/invoiceSlice";
import {
  getOptionList,
  getpreferredContactList,
} from "../../reduxSlices/applicationSlice";
import { clearLoginData, isLoggedInUpdate } from "../../reduxSlices/loginSlice";
import MessageIndicator from "../../components/SnackBar";
import Backdrop from "../../components/Backdrop/";
import { withRouter } from "react-router-dom";
import TablePagination from "@material-ui/core/TablePagination";
import config from "../../app/config";
import sha256 from "js-sha256";
import moment from 'moment';
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  container: {
    padding: "1rem 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  profileFont: {
    fontSize: "1.8rem",
    fontWeight: 500,
    textAlign: "center",
    lineHeight: "2.5",
  },
  btnContainer: {
    display: "flex",
    gap: "6px",
  },
  btnStyle: {
    background: "#ffff",
    color: "#3f51b5",
    "&:hover": {
      background: "#fff",
    },
  },
  taHeading: {
    background: "#005598 !important",
    fontWeight: "bold",
    fontSize: "15px",
    textAlign: "center",
    color: "#fff",
  },
  tAmount: {
    textAlign: "end",
  },
  tblStyle: {
    textAlign: "left",
  },
  tblStylecenter: {
    textAlign: "center",
  },
  tblleftStyle:{
     textAlign: "right",
  }
});

function Invoices(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [studentID, setStudentID] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPerPage1, setRowsPerPage1] = useState(5);
  const [page1, setPage1] = useState(0);
  const [paidInvoice, setPaidInvoice] = useState([]);
  const [unpaidInvoice, setUnpaidInvoice] = useState([]);
  const [error, setError] = useState({
    isError: false,
    message: "",
    showSnackbar: false,
  });
  const [studentId, setStudentId] = useState("");

  const getStudentDetails = useSelector(
    (state) => state.applicationData.applicantStatus.ses_applicantstatus,
  );

  const applicantStatus = useSelector(
    (state) => state.applicationData.applicantStatus,
  );

  useEffect(() => {
    if (getStudentDetails) {
      setStudentId(getStudentDetails.ses_studentid);
    }
  }, [getStudentDetails]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleChangePage1 = (event, newPage) => {
    setPage1(newPage);
  };

  const handleChangeRowsPerPage1 = (event) => {
    setRowsPerPage1(+event.target.value);
    setPage1(0);
  };
  const getPaidInvoiceData = useSelector(
    (state) => state.invoiceData.invoicePaidData,
  );
  const getUnpaidInvoiceData = useSelector(
    (state) => state.invoiceData.invoiceUnpaidData,
  );
  const dataFetchingStatus = useSelector(
    (state) => state.invoiceData.dataFetchingStatus,
  );
  const optionList = useSelector((state) => state.applicationData.optionList);
  const preferredContactList = useSelector(
    (state) => state.applicationData.preferredContactList,
  );
  const errorMessage = useSelector((state) => state.invoiceData.errorMessage);
  const errorStatusCode = useSelector(
    (state) => state.invoiceData.errorStatusCode,
  );

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
  function handleFile(event, invoiceId) {
    let formDataValue = {};
    if (event.target.value) {
      formDataValue.invoiceId = invoiceId;
      formDataValue.studentId = studentId;
      formDataValue.name = event.target.files[0].name;
      getBase64(event.target.files[0]).then((data) => {
        formDataValue.document = data.split(",")[1];
        // formDataValue.document=data.replace("data:application/pdf;base64,","");
        dispatch(saveFileUploadData(formDataValue));
      });
      event.target.value = null;
    }
  }

  const handlePayment = (paymentDetails) => {
    window.open(
      `${config.API_BASE_URL}payment?token=${window.localStorage.getItem(
        "x-auth-token",
      )}&mobile=${window.localStorage.getItem(
        "x-auth-mobile",
      )}&email=${window.localStorage.getItem("x-auth-email")}&amount=${
        paymentDetails.amount
      }&accountId=${
        paymentDetails.accountId
      }&studentId=${studentId}&invoiceId=${
        paymentDetails.invoiceId
      }&contactId=${window.localStorage.getItem("x-auth-contactId")}`,
      "_blank",
    );
  };

  const paymentParams = {
    command: "PURCHASE",
    access_code: config.ACCESSCODE,
    merchant_identifier: config.MERCHANTIDENTIFIER,
    merchant_extra: studentId,
    merchant_extra2: localStorage.getItem("x-auth-contactId"),
    currency: "EGP",
    language: "en",
    customer_email: localStorage.getItem("x-auth-email"),
    order_description: "Class Registration Fee",
    return_url: config.return_url,
  };

  const funcOptionList = (status) => {
    var value;
    if (optionList?.length != 0) {
      optionList?.map((ele) => {
        if (ele.attributevalue === status) {
          value = ele.value;
        }
      });
    }
    return value;
  };

  const funcstatusList = (status) => {
    var value;
    if (preferredContactList?.length != 0) {
      preferredContactList?.map((ele) => {
        if (ele.attributevalue === status) {
          value = ele.value;
        }
      });
    }
    return value;
  };
  useEffect(() => {
    let entity = "invoice";
    let attributename = "ses_invoicetype";
    dispatch(getOptionList(entity, attributename));
  }, [dispatch]);

  useEffect(() => {
    let entity = "invoice";
    let attributename = "statuscode";
    dispatch(getpreferredContactList(entity, attributename));
  }, [dispatch]);

  const generatehash256SignatureForTokenization = (
    access_code,
    amount,
    merchant_reference,
    command,
    currency,
    customer_email,
    merchant_identifier,
    merchant_extra,
    merchant_extra1,
    merchant_extra2,
    merchant_extra3,
    order_description,
  ) => {
    const message = `${config.SHAREQUESTPHRASE}access_code=${access_code}amount=${amount}command=${command}currency=${currency}customer_email=${customer_email}language=enmerchant_extra=${merchant_extra}merchant_extra1=${merchant_extra1}merchant_extra2=${merchant_extra2}merchant_extra3=${merchant_extra3}merchant_identifier=${merchant_identifier}merchant_reference=${merchant_reference}order_description=${order_description}${config.SHAREQUESTPHRASE}`;
    return sha256.sha256(message);
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const num = Number(value);
    if (Number.isNaN(num)) return value;
    return `$ ${num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
  };
  let amountData = "";
  let unpaidTableData = "";
  let paidTableData = "";
  let paymentsTotalData = "";
  if (unpaidInvoice.length > 0) {
    let amountPaidEuro = "0";
    let amountPaidEgypt = "0";
    const data = [
      { title: "One", prix: 100 },
      { title: "Two", prix: 200 },
      { title: "Three", prix: 300 },
    ];

    let sumofTotalAmount = unpaidInvoice.reduce(
      (total, currentValue) => (total = total + currentValue.totalamount),
      0,
    );
    let finalTotalAmount = sumofTotalAmount;
    let sumofAmountPaid = unpaidInvoice.reduce(
      (total, currentValue) => (total = total + currentValue.ses_amountpaid),
      0,
    );

    let finalAmountPaid = sumofAmountPaid;

    let finalTotalVariation = finalTotalAmount - finalAmountPaid;
    const fixedNumber = Number.parseFloat(finalTotalVariation).toFixed(2);
    let finalTotal = String(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    unpaidInvoice.map((row) => {
      if (
        row._transactioncurrencyid_value ===
        "4b40fd15-61f8-ea11-a815-000d3a654128"
      ) {
        amountPaidEuro =
          parseInt(amountPaidEuro) +
          parseInt(
            row.ses_totalchargedamount === null
              ? 0
              : row.ses_totalchargedamount,
          );
      } else {
        amountPaidEgypt =
          parseInt(amountPaidEgypt) +
          parseInt(
            row.ses_totalchargedamount === null
              ? 0
              : row.ses_totalchargedamount,
          );
      }
    });

    unpaidTableData =
      unpaidInvoice.length > 0
        ? unpaidInvoice
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => (
              <TableRow key={index}>
                <TableCell className={classes.tblStyle} align="right">
                  {
                    row[
                      "ses_invoicedate@OData.Community.Display.V1.FormattedValue"
                    ]
                  }
                </TableCell>
                <TableCell className={classes.tblStyle} align="right">
                  {row.invoicenumber}
                </TableCell>
                <TableCell className={classes.tblStyle} align="right">
                  {" "}
                  {funcOptionList(row.ses_invoicetype)}
                </TableCell>
                <TableCell
                  className={classes.tblStyle}
                  style={{ width: "23%" }}
                  align="justify"
                >
                  {row.description}
                </TableCell>
                <TableCell className={classes.tblStyle} align="right">
                  {funcstatusList(row.statuscode)}
                </TableCell>
                <TableCell className={classes.tblleftStyle} align="right">
                  {/* Egyptian Pound CURRENCY ID  
                3258b4b1-2fb8-ea11-a812-000d3ab39e1b
               EURO CURRENCY ID  
                4b40fd15-61f8-ea11-a815-000d3a654128 */}
                  {formatCurrency(row.totalamount)}
                </TableCell>
                <TableCell className={classes.tblleftStyle} align="right">
                  {formatCurrency(row.ses_amountpaid)}
                </TableCell>
                <TableCell className={classes.tblleftStyle} align="right">
                  {formatCurrency(row.ses_amountremaining)}
                </TableCell>

                <TableCell  align="right">
                  {row.ses_amountpaid === null ||
                  row.ses_amountpaid < row.totalamount ? (
                    <Typography
                      component="div"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "1rem",
                        width: "100%",
                      }}
                    >
                      <Typography>
                        <form
                          method="post"
                          action={`${config.PURCHASEHOSTURL}`}
                        >
                          {Object.keys(
                            paymentParams,
                            (paymentParams.merchant_reference = `${studentId}-${new Date().getMilliseconds()}`),
                            (paymentParams.amount =
                              row.ses_totalchargedamount * 100),
                            (paymentParams.merchant_extra1 = row.invoiceid),
                            (paymentParams.merchant_extra3 =
                              row._customerid_value),
                          ).map((data, index) => (
                            <input
                              type="hidden"
                              name={data}
                              key={index}
                              value={paymentParams[data]}
                            />
                          ))}
                          <input
                            type="hidden"
                            name="signature"
                            value={generatehash256SignatureForTokenization(
                              paymentParams.access_code,
                              paymentParams.amount,
                              paymentParams.merchant_reference,
                              paymentParams.command,
                              paymentParams.currency,
                              paymentParams.customer_email,
                              paymentParams.merchant_identifier,
                              paymentParams.merchant_extra,
                              paymentParams.merchant_extra1,
                              paymentParams.merchant_extra2,
                              paymentParams.merchant_extra3,
                              paymentParams.order_description,
                            )}
                          />
                          <Typography
                            component="div"
                            className={classes.tblStyle}
                            align="center"
                          >
                            <Button
                              variant="outlined"
                              color="primary"
                              style={{ textTransform: "none" }}
                              type="submit"
                              disabled={true} // demo purpose
                            >
                              Make a Payment
                            </Button>
                          </Typography>
                        </form>
                      </Typography>
                    </Typography>
                  ) : (
                    <Typography
                      component="div"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "1rem",
                        width: "100%",
                      }}
                    >
                      <Typography>
                        <form
                          method="post"
                          action={`${config.PURCHASEHOSTURL}`}
                        >
                          {Object.keys(
                            paymentParams,
                            (paymentParams.merchant_reference = `${studentId}-${new Date().getMilliseconds()}`),
                            (paymentParams.amount =
                              row.ses_totalchargedamount * 100),
                            (paymentParams.merchant_extra1 = row.invoiceid),
                            (paymentParams.merchant_extra3 =
                              row._customerid_value),
                          ).map((data, index) => (
                            <input
                              type="hidden"
                              name={data}
                              key={index}
                              value={paymentParams[data]}
                            />
                          ))}
                          <input
                            type="hidden"
                            name="signature"
                            value={generatehash256SignatureForTokenization(
                              paymentParams.access_code,
                              paymentParams.amount,
                              paymentParams.merchant_reference,
                              paymentParams.command,
                              paymentParams.currency,
                              paymentParams.customer_email,
                              paymentParams.merchant_identifier,
                              paymentParams.merchant_extra,
                              paymentParams.merchant_extra1,
                              paymentParams.merchant_extra2,
                              paymentParams.merchant_extra3,
                              paymentParams.order_description,
                            )}
                          />
                          <Typography
                            component="div"
                            className={classes.tblStyle}
                            align="center"
                          >
                            <Button
                              variant="outlined"
                              color="primary"
                              style={{ textTransform: "none" }}
                              type="submit"
                              disabled={true}
                            >
                              Make a Payment
                            </Button>
                          </Typography>
                        </form>
                      </Typography>
                    </Typography>
                  )}

                  {/* {row._transactioncurrencyid_value ===
                  "3258b4b1-2fb8-ea11-a812-000d3ab39e1b" ? (
                    <Typography
                      component="div"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "1rem",
                        width: "100%",
                      }}
                    >
                      {applicantStatus.ses_applicantstatus !== undefined && (
                        <Typography>
                          <form
                            method="post"
                            action={`${config.PURCHASEHOSTURL}`}
                          >
                            {Object.keys(
                              paymentParams,
                              (paymentParams.merchant_reference = `${studentId}-${new Date().getMilliseconds()}`),
                              (paymentParams.amount =
                                row.ses_totalchargedamount * 100),
                              (paymentParams.merchant_extra1 = row.invoiceid),
                              (paymentParams.merchant_extra3 =
                                row._customerid_value)
                            ).map((data, index) => (
                              <input
                                type="hidden"
                                name={data}
                                key={index}
                                value={paymentParams[data]}
                              />
                            ))}
                            <input
                              type="hidden"
                              name="signature"
                              value={generatehash256SignatureForTokenization(
                                paymentParams.access_code,
                                paymentParams.amount,
                                paymentParams.merchant_reference,
                                paymentParams.command,
                                paymentParams.currency,
                                paymentParams.customer_email,
                                paymentParams.merchant_identifier,
                                paymentParams.merchant_extra,
                                paymentParams.merchant_extra1,
                                paymentParams.merchant_extra2,
                                paymentParams.merchant_extra3,
                                paymentParams.order_description
                              )}
                            />
                            <Typography
                              component="div"
                              className={classes.tblStyle}
                              align="center"
                            >
                              <Button
                                variant="outlined"
                                color="primary"
                                style={{ textTransform: "capitalize" }}
                                type="submit"
                                // disabled={row.ses_totalchargedamount === 0}
                              >
                                Make A Payment
                              </Button>
                            </Typography>
                          </form>
                        </Typography>
                      )}
                    </Typography>
                  ) : row._transactioncurrencyid_value ===
                    "4b40fd15-61f8-ea11-a815-000d3a654128" ? (
                    <Button
                      variant="outlined"
                      color="primary"
                      style={{ textTransform: "capitalize" }}
                      type="submit"
                      onClick={() =>
                        handlePayment({
                          invoiceId: row.invoiceid,
                          amount: row.ses_totalchargedamount,
                          accountId: row._customerid_value,
                        })
                      }
                      // disabled={row.ses_totalchargedamount === 0 || true}
                    >
                      Make A Payment
                    </Button>
                  ) : null} */}
                </TableCell>
                {/* <TableCell>
                  <InputLabel htmlFor={row.name}>
                    <input
                      // style={{display:"none"}}
                      margin="normal"
                      id={row.name}
                      label="Choose File"
                      type="file"
                      autoComplete="Choose File"
                      name="Proof of Payment"
                      onChange={(event) => handleFile(event, row.invoiceid)}
                      hidden
                    />
                    <Button
                      style={{
                        textTransform: "capitalize",
                        textAlign: "center",
                      }}
                      color="primary"
                      variant="outlined"
                      component="span"
                    >
                      Provide Proof of Payment
                    </Button>
                  </InputLabel>
                </TableCell> */}
              </TableRow>
            ))
        : [];

    amountData = (
      <div>
        <p className={classes.tAmount}>
          <span>Total: </span>
          <span>$ {finalTotal}</span>
        </p>
        {/* <p className={classes.tAmount}>
          <span>Total EURO: </span>
          <span>€{amountPaidEuro}</span>
        </p> */}
      </div>
    );
  }
  if (paidInvoice.length > 0) {
    // table rows
    paidTableData =
      paidInvoice.length > 0
        ? paidInvoice
            .slice(page1 * rowsPerPage1, page1 * rowsPerPage1 + rowsPerPage1)
            .map((row, index) => (
              <TableRow key={index}>
                <TableCell className={classes.tblStylecenter} align="right">
                  {moment(row.ses_paymentdate).format("MM/DD/YYYY")}
                </TableCell>
                <TableCell className={classes.tblStyle} align="left">
                  {
                    row[
                      "_ses_invoiceid_value@OData.Community.Display.V1.FormattedValue"
                    ]
                  }
                </TableCell>
                <TableCell className={classes.tblStyle} align="left">
                  {
                    row[
                      "ses_paymenttype@OData.Community.Display.V1.FormattedValue"
                    ]
                  }
                </TableCell>
                <TableCell align="right">
                  {formatCurrency(row.ses_paymentamt)}
                </TableCell>
              </TableRow>
            ))
        : [];

    // total for Payments section (sum of ses_paymentamt)
    const paymentsTotalRaw = paidInvoice.reduce(
      (total, currentValue) =>
        total + (currentValue.ses_paymentamt || 0),
      0,
    );
    const paymentsTotalFixed = Number.parseFloat(paymentsTotalRaw).toFixed(2);
    const paymentsTotalFormatted = String(paymentsTotalFixed).replace(
      /\B(?=(\d{3})+(?!\d))/g,
      ",",
    );
    paymentsTotalData = (
      <div>
        <p className={classes.tAmount}>
          <span>Total: </span>
          <span>$ {paymentsTotalFormatted}</span>
        </p>
      </div>
    );
  }
  const InvData = () => {
    if (studentId && studentId.length > 0) {
      dispatch(
        getInvoiceData(
          studentId,
          window.localStorage.getItem("x-auth-contactId"),
        ),
      );
    }
  };

  useEffect(() => {
    InvData();
  }, [studentId]);
  useEffect(() => {
    // if(getPaidInvoiceData&&getPaidInvoiceData.length>0){
    //   setUnpaidInvoice([...getPaidInvoiceData].sort((a, b) => new Date(b['ses_invoicedate@OData.Community.Display.V1.FormattedValue']) - new Date(a['ses_invoicedate@OData.Community.Display.V1.FormattedValue'])))
    // }
    if (getUnpaidInvoiceData && getUnpaidInvoiceData.length > 0) {
      setUnpaidInvoice(
        [...getUnpaidInvoiceData].sort(
          (a, b) =>
            new Date(
              b["ses_invoicedate@OData.Community.Display.V1.FormattedValue"],
            ) -
            new Date(
              a["ses_invoicedate@OData.Community.Display.V1.FormattedValue"],
            ),
        ),
      );
    }
    if (getPaidInvoiceData && getPaidInvoiceData.length > 0) {
      if (getPaidInvoiceData && getPaidInvoiceData.length > 0) {
        setPaidInvoice(
          [...getPaidInvoiceData].sort(
            (a, b) =>
              new Date(
                b["ses_paymentdate@OData.Community.Display.V1.FormattedValue"],
              ) -
              new Date(
                a["ses_paymentdate@OData.Community.Display.V1.FormattedValue"],
              ),
          ),
        );
      }
    }
  }, [getPaidInvoiceData, getUnpaidInvoiceData]);

  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      if (errorStatusCode === 401) {
        let error = {
          isError: false,
          message: "Session Expired",
          showSnackbar: true,
        };
        setError(error);
        setTimeout(() => {
          handelLogout();
        }, 1600);
      } else {
        let error = {
          isError: false,
          message: errorMessage,
          showSnackbar: true,
        };
        setError(error);
      }
    }
  }, [errorMessage, errorStatusCode]);

  const handleClose = () => {
    let errorCopy = { ...error };
    errorCopy.showSnackbar = false;
    setError(errorCopy);
  };

  const handelLogout = () => {
    dispatch(clearLoginData());
    window.localStorage.removeItem("x-auth-token");
    window.localStorage.removeItem("x-auth-fullname");
    window.localStorage.removeItem("x-auth-contactId");
    window.localStorage.removeItem("isUserLoggedIn");
    dispatch(isLoggedInUpdate(false));
    dispatch(clearErrorStatusCode());
    dispatch(clearErrorMessage());
    props.history.push("/login");
  };

  useEffect(() => {
    if (getStudentDetails) {
      setStudentID(getStudentDetails.ses_studentid);
    }
  }, [getStudentDetails]);

  return (
    <Aux>
      <MessageIndicator
        open={error.showSnackbar}
        message={error.message}
        handleClose={handleClose}
      />
      <Backdrop show={dataFetchingStatus} />
      <Grid className={classes.container}>
        <Container fixed>
          <Typography component="div" className={classes.profileFont}>
            Invoices
          </Typography>

          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.taHeading} align="right">
                    Date
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    Invoice
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    Type
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    Description
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    Status
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    Total Amount
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    Amount Paid
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    Amount Remaining
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    Action
                  </TableCell>
                  {/* <TableCell className={classes.taHeading} align="right">
                    Proof of Payment
                  </TableCell> */}
                </TableRow>
              </TableHead>
              <TableBody>{unpaidTableData}</TableBody>
            </Table>
            <TablePagination
              style={{ textTransform: "capitalize" }}
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={unpaidInvoice.length > 0 ? unpaidInvoice.length : 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </TableContainer>
          {amountData}
        </Container>
      </Grid>
      <Grid className={classes.container}>
        <Container fixed>
          <Typography component="div" className={classes.profileFont}>
            Payments
          </Typography>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <TableCell className={classes.taHeading}>Date</TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    Invoice
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    Type
                  </TableCell>
                  <TableCell className={classes.taHeading} align="right">
                    Amount
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{paidTableData}</TableBody>
            </Table>
            <TablePagination
              style={{ textTransform: "capitalize" }}
              rowsPerPageOptions={[5, 10, 25, 100]}
              component="div"
              count={paidInvoice.length > 0 ? paidInvoice.length : 0}
              rowsPerPage={rowsPerPage1}
              page={page1}
              onChangePage={handleChangePage1}
              onChangeRowsPerPage={handleChangeRowsPerPage1}
            />
          </TableContainer>
          {paymentsTotalData}
        </Container>
      </Grid>
    </Aux>
  );
}

export default withRouter(Invoices);
